import { BuildClass } from '../../universal';
import { React, _ } from '../lib';
import { isJSX, j2r } from './component-react';
import { Bindings } from './ui5';
export class J2rToolbar extends React.Component {
    constructor(props) {
        super(props);
        Bindings(this, [this.eval]);
        if (this.props.widthLHS != null && this.props.widthRHS != null) {
            console.warn('Not supposed to have widths defined for both sides', this);
        }
        if (this.props.widthLHS == null && this.props.widthRHS == null) {
            console.warn('J2rToolbar should have a defined width for either LHS or RHS', this);
        }
    }
    render() {
        return (React.createElement("div", { className: BuildClass({
                [this.props.cl ?? '']: true,
                'j2r-toolbar': true,
            }) },
            React.createElement("div", { className: "lhs side", style: { width: this.getWidthLHS() } }, _.compact(_.map(this.props.lhs, this.eval))),
            React.createElement("div", { className: "rhs side", style: { width: this.getWidthRHS() } }, _.compact(_.map(this.props.rhs, this.eval)))));
    }
    getWidthLHS() {
        if (this.props.widthLHS != null) {
            return `${this.props.widthLHS}px`;
        }
        else if (this.props.widthRHS != null) {
            return `calc(100% - ${this.props.widthRHS}px)`;
        }
        return undefined;
    }
    getWidthRHS() {
        if (this.props.widthRHS != null) {
            return `${this.props.widthRHS}px`;
        }
        else if (this.props.widthLHS != null) {
            return `calc(100% - ${this.props.widthLHS}px)`;
        }
        return undefined;
    }
    eval(cmpt, index) {
        if (cmpt == null) {
            return React.createElement(React.Fragment, null);
        }
        if (isJSX(cmpt)) {
            return React.cloneElement(cmpt, {
                key: String(index),
                className: BuildClass({
                    [cmpt.props.cl]: true,
                    'toolbar-item': true,
                }),
            });
        }
        const cmptConcrete = _.isFunction(cmpt) ? cmpt() : cmpt;
        return j2r({
            ...cmptConcrete,
            cl: BuildClass({
                [cmptConcrete?.cl ?? '']: true,
                'toolbar-item': true,
            }),
            key: cmptConcrete.key ?? index,
        });
    }
}
//# sourceMappingURL=component-toolbar.js.map